// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconWokb } from "../../../icons/mono/build/icon-wokb.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const WokbIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconWokb.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  WokbIcon.displayName = 'WokbIcon';
}

export default WokbIcon;